import {IBorderRadius} from './common/borderRadius';
import {IPresentation} from './presentation';

export interface IPresentationTheme {
    _id?: string;
    themeName: string;
    favoriteColors?: string[];
    fontSizes: FontSize[];
    elementStyles?: {
        textElement?: {
            color?: string;
            borderRadius?: IBorderRadius;
            backgroundColor?: string;
            fontSize?: FontSize;
        };
        questionElement?: QuestionElement;
    };
    fonts: Font[];
    defaultFonts: Font[];
    allowedUserIds?: string[];
    lastModified: number;
    ownerId?: string;
    presentations?: Pick<IPresentation, '_id' | 'name'>[];
}

export type FontSize = {
    size: FONT_SIZE;
    value: number;
};

export type Font = {
    name: string;
    url: string;
    selected?: boolean;
};

export type QuestionElement = {
    questionFontSize?: FontSize;
    answerFontSize?: FontSize;
    commentFontSize?: FontSize;
};

export enum FONT_SIZE {
    EXTRA_SMALL = 'EXTRA SMALL',
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM',
    LARGE = 'LARGE',
    EXTRA_LARGE = 'EXTRA LARGE',
}

export type FontSizeTranslationKey =
    | 'presentationThemesPage.fonts.size.extraSmall'
    | 'presentationThemesPage.fonts.size.small'
    | 'presentationThemesPage.fonts.size.medium'
    | 'presentationThemesPage.fonts.size.large'
    | 'presentationThemesPage.fonts.size.extraLarge';

export const getFontSizeTranslationKey = (fontSize: FONT_SIZE): FontSizeTranslationKey | '' => {
    switch (fontSize) {
        case FONT_SIZE.EXTRA_SMALL:
            return 'presentationThemesPage.fonts.size.extraSmall';
        case FONT_SIZE.SMALL:
            return 'presentationThemesPage.fonts.size.small';
        case FONT_SIZE.MEDIUM:
            return 'presentationThemesPage.fonts.size.medium';
        case FONT_SIZE.LARGE:
            return 'presentationThemesPage.fonts.size.large';
        case FONT_SIZE.EXTRA_LARGE:
            return 'presentationThemesPage.fonts.size.extraLarge';
        default:
            return '';
    }
};
